import {
    Component, OnInit, AfterViewInit, Input, OnChanges,
    Output, EventEmitter, ViewChild
} from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { AdminService } from '../service/admin.service';
import { UtilService } from '../../service/util.service';
import { OttPlayerRequest } from './ott-players-request';
import { OttPlayerResponse } from './ott-players-response';
import * as constants from '../../app.constants';
import { NotificationsService } from 'angular2-notifications';
declare let $: any;

@Component({

    selector: 'custom-modals',
    template: require('./custom-modals.component.html'),
    styles: [require('./custom-modals.component.css')]
})
export class CustomModalsComponent implements OnChanges {
    @Input() public type;
    @Input() public body;
    @Input() public heading;
    @Output() public resetType = new EventEmitter();
    @ViewChild('deleteModal') public deleteModal: ModalComponent;
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private adminService: AdminService) {
    }

    public ngOnChanges() {
        switch (this.type) {
            case 1: { this.openDeleteModal(); break; };
            default: return null;
        }
    }

    public openDeleteModal() {
        this.deleteModal.open();
    }

    public closeDeleteModal() {
        this.deleteModal.close();
    }

    public emitResetValue(value) {
        if (value) {
            this.resetType.emit(true);
        } else {
            this.resetType.emit(false);
        }
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/custom-modals/custom-modals.component.ts